module.exports = __webpack_public_path__ + "static/media/faq-7.8a42cbe4.png";